import { useNavigate } from "react-router-dom";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import useAppState from "../../../context/AppContext";
import { useEffect, useState } from "react";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";
import { IApiErrors, IPreContractDocument } from "../../../context/model";
import { initSmsSignatureCode, listPreContractDocuments } from "../../../services/CustomerApiService";
import { AxiosError } from "axios";
import { useForm } from "react-hook-form";import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import PreContractDocumentComponent from "../../../components/info-signature/PreContractDocumentComponent";
import LoaderModal from "../../../modals/common/LoaderModal";
import PhoneNumberConfirmModal from "../../../modals/common/PhoneNumberConfirmModal";

type SignaturePreDocumentData = {
  phoneNumber: string;
  isForeignMobile: boolean;
}

export default function REInfoSignatureDocumentBloc() {

    const navigate = useNavigate();
    const {
      state: { proposition, updatedProposition, jwtToken, preContractDocuments},
      dispatch,
    } = useAppState();
    const [contractDocuments, setContractDocuments] = useState<IPreContractDocument[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string | null>();
    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);

  
    const validationSchema = Yup.object().shape({
      phoneNumber: Yup.string()
        .when('isForeignMobile', {
            is: false,
            then: Yup.string()
                    .required(ERROR_MESSAGES.requiredMsg)
                    .matches(/^(0[6-7])([ .-]?\d{2}){4}$/, ERROR_MESSAGES.invalidFrenchMobile)
                    .min(14, ERROR_MESSAGES.invalidMsg),
        })
        .when('isForeignMobile', {
            is: true,
            then: Yup.string()
                    .required(ERROR_MESSAGES.requiredMsg)
                    .matches(/^(?:\+|00)[0-9]\d{1,14}$/, ERROR_MESSAGES.invalidForeignMobile)
                    .test("number-is-french", ERROR_MESSAGES.invalidFrenchMobileWithIndicator, async (value, values) => {
                      if(!value) {
                        return false;
                      }
                      const isFrenchNumber = value.startsWith("0033") || value.startsWith("+33");
                      return !isFrenchNumber;
                    }),      
            }), 
    });

    const {
      register, 
      getValues,
      setValue,
      handleSubmit,
      watch,
      clearErrors,
      formState: { errors },
    } = useForm<SignaturePreDocumentData>({
      mode: "onBlur",
      reValidateMode: "onChange",
      defaultValues: {
        isForeignMobile: updatedProposition?.isForeignMobile ? updatedProposition.isForeignMobile : false,
        phoneNumber: updatedProposition?.phoneNumber  ? 
          updatedProposition?.isForeignMobile ?   
          updatedProposition.phoneNumber.replaceAll(' ', "" ) :  
          updatedProposition.phoneNumber.replace(/[^\dA-Z]/g, '').replace(/(.{2})/g, '$1 ').trim() :
          ""
      },
      resolver: yupResolver(validationSchema),
    });
  
    useEffect(() => {
      if (preContractDocuments?.length) {
        setContractDocuments(preContractDocuments);
        return;
      }
      const listDocuments = async () => {
        const res = await listPreContractDocuments(jwtToken!.accessToken, proposition!.propositionId);
        setLoading(false);
        dispatch({type: 'LIST_PRE_CONTRACT_DOCUMENT', preContractDocuments: res.data});
        setContractDocuments(res.data);
      }
  
      setErrorMsg(null);
      setLoading(true);
      listDocuments()
        .catch(error => {
          setLoading(false);
          const err = error as AxiosError;
          console.log(err);
          if(err.response && err.response.status === 400) {
            const errorData = err.response?.data as IApiErrors;
            setErrorMsg("Erreur: " + errorData.message);
          } else {
            setErrorMsg("Une erreur technique est survenue ");
          }
      });
    }, []);
  
    const onNextAction = async () => {
      const acceptedDocs = contractDocuments.filter(ele => ele.accepted);

      if (contractDocuments.length >0 && acceptedDocs?.length === contractDocuments.length) {
        setOpenConfirmModal(true)
        
      } else {
        setErrorMsg('Veuillez prendre connaissance et accepter tous les documents précontractuels');
      }
    }

    const onConfirmAction =async () => {
      setLoading(true);
      try {
        const token = jwtToken!.accessToken;
        const phoneNumber = getValues("phoneNumber").replace(/ /g, '');
        const res = await initSmsSignatureCode(token, proposition!.propositionId, phoneNumber);
  
        dispatch({type: 'INIT_SMS', sessionUid: res.data.sessionUid, phoneNumberSMS: phoneNumber});
        const nextUrl = APP_RETIREMENT_URLS.infoSignatureConfirmPage
        dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
        navigate({
            pathname: nextUrl,
            search: `?id=${proposition!.propositionId}`,
        });         
       }catch (error) {
        setLoading(false);
        const err = error as AxiosError;
        console.log(err);
        if(err.response && err.response.status === 400) {
          const errorData = err.response?.data as IApiErrors;
          setErrorMsg("Erreur: " + errorData.message);
        } else {
          setErrorMsg("Une erreur technique est survenue ");
        }
      }
    }

    const onDocumentUpdate = (doc: IPreContractDocument) => {
      const updatedDocuments = contractDocuments.map(ele => {
        if (ele.key === doc.key) {
          return doc;
        } else {
          return ele;
        }
      })
  
      dispatch({type: 'LIST_PRE_CONTRACT_DOCUMENT', preContractDocuments: updatedDocuments});
      setContractDocuments(updatedDocuments);
    }
      const onPreviousAction = async () => {
        const url = APP_RETIREMENT_URLS.retirementRecapPage

        dispatch({type: 'BACK_INFO_STEP', path: url});
        navigate({
            pathname: url,
            search: `?id=${proposition!.propositionId}`,
        });         
      }

       const handleChangeisForeignMobileCheckbox = (e: any) => {
        setValue("isForeignMobile", e.target.checked);
        clearErrors("phoneNumber");

        if (e.target.checked) {
            setValue("phoneNumber", "+");     
        } else {
            setValue("phoneNumber", "");
        }   
      }
  
      const handleChangePhoneNumber = (e: any) => {
          const regexSpace = new RegExp("(.{"+ 2 + "})", "g");
          let target = e.currentTarget, position = target.selectionEnd, length = target.value.length;
          target.value = target.value.replace(/\s/g, '').replace(regexSpace, '$1 ').trim();
          target.selectionEnd = position += ((target.value.charAt(position - 1) === ' ' && target.value.charAt(length - 1) === ' ' && length !== target.value.length) ? 1 : 0);
          setValue && setValue("phoneNumber", target.value);
      }
      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Vos documents précontractuels</h2>
            <p className="text m-y-sm">
              Afin d'accéder à la signature éléctronique de votre contrat, 
              merci de bien vouloir prendre connaissance et accepter les documents suivants
            </p>

            <div>
              {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
            </div>
            <form>
              {contractDocuments.map((ele, i) => {
                return <PreContractDocumentComponent key={ele.key} preContractDocument={ele} onDocumentUpdate={onDocumentUpdate} handleSetMessageError={(message: string)=> setErrorMsg(message)} />;
              })}
            </form>
            {loading && <LoaderModal hasMessage={true}/>}
      
            <StickButtonsBloc showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={onNextAction}/>

            {
              openConfirmModal && 
              <PhoneNumberConfirmModal  
                isOpen={openConfirmModal} 
                onConfirmAction={handleSubmit(onConfirmAction)} 
                onCloseModal={() => setOpenConfirmModal(false)}
                watch={watch}
                register={register}
                errors={errors}
                handleChangeisForeignMobileCheckbox={handleChangeisForeignMobileCheckbox}
                handleChangePhoneNumber={handleChangePhoneNumber}
              />
            }
          </div>

        </div>
      )
}